import Dunk1 from '../assets/imgs/shoes/dunkhigh1.jpg';
import Airforce1 from '../assets/imgs/shoes/Airforce1.jpg';
import Airmax from '../assets/imgs/shoes/airmax270-1.jpg';
import Airmax97 from '../assets/imgs/shoes/airmax97-1.jpg';
import Airmax90 from '../assets/imgs/shoes/airmax90-1.jpg';
import Airmax90ltr from '../assets/imgs/shoes/airmax90ltr-1.jpg';
import Airforce07 from '../assets/imgs/shoes/airforce07-1.jpg';
import airforce07lv8 from '../assets/imgs/shoes/airforce07lv8-1.jpg';
import Bigkids1 from '../assets/imgs/shoes/bigkidsairforce-1.jpg';
import Courtvision from '../assets/imgs/shoes/courtvision-1.jpg';
import Ozweego from '../assets/imgs/shoes/originalsozweego-1.jpg';
import Originalsstan from '../assets/imgs/shoes/originalsstan-1.jpg';
import Essentialsznsored from '../assets/imgs/shoes/essentialsznsored.jpg';
import Predatorfreak from '../assets/imgs/shoes/predatorfreak-1.jpg';
import Samba from '../assets/imgs/shoes/samba-1.jpg';
import Newbalance550 from '../assets/imgs/shoes/newbalance550-1.jpg';
import Newbalance574 from '../assets/imgs/shoes/newbalance574-1.jpg';
import Newbalance574o from '../assets/imgs/shoes/newbalance574-2.jpg';
import Newbalance574r from '../assets/imgs/shoes/newbalance574r-1.jpg';
import Newbalance9060 from '../assets/imgs/shoes/newbalance9060-1.jpg';
import Newbalancect302 from '../assets/imgs/shoes/newbalancect302-1.jpg';
import Newbalance1906r from '../assets/imgs/shoes/newbalance1906r-1.jpg';
import Newbalance650 from '../assets/imgs/shoes/newbalance650-1.jpg';
import Newbalance350 from '../assets/imgs/shoes/newbalance530-1.jpg';
import Newbalance574se from '../assets/imgs/shoes/newbalance574se-1.jpg';
import Pumasuede21 from '../assets/imgs/shoes/pumasuede21-1.jpg';
import Pumamirage from '../assets/imgs/shoes/pumamirage-1.jpg';
import Pumaaxelion from '../assets/imgs/shoes/pumaaxelion-1.jpg';
import Pumatrc from '../assets/imgs/shoes/pumatrc-1.jpg';
import Pumacapro from '../assets/imgs/shoes/pumacapro-1.jpg';
import Pumacaven from '../assets/imgs/shoes/pumacaven-1.jpg';
import Pumarider from '../assets/imgs/shoes/pumarider-1.jpg';
import Pumasoft from '../assets/imgs/shoes/pumasoft-1.jpg';
import Pumars from '../assets/imgs/shoes/pumars-1.jpg';
import Pumarstrick from '../assets/imgs/shoes/pumarstrick-1.jpg';



export const items = [
  {
    id: 1,
    name: "Nike Dunk High Retro Casual",
    category: "Nike",
    price: "125.00",
    image: Dunk1,
  },
  {
    id: 2,
    name: "Nike Air Force 1 Low Casual",
    category: "Nike",
    price: "89.99",
    image: Airforce1,
  },
  {
    id: 3,
    name: "Nike Air Max 270 Casual",
    category: "Nike",
    price: "160.00",
    image: Airmax,
  },
  {
    id: 4,
    name: "Nike Air Max 97 Casual",
    category: "Nike",
    price: "175.00",
    image: Airmax97,
  },
  {
    id: 5,
    name: "Nike Air Max 90 Casual",
    category: "Nike",
    price: "140.00",
    image: Airmax90,
  },
  {
    id: 6,
    name: "Nike Air Force '07 split Casual",
    category: "Nike",
    price: "130.00",
    image: Airforce07,
  },
  {
    id: 7,
    name: "Nike Air Force '07 LV8 Casual",
    category: "Nike",
    price: "130.00",
    image: airforce07lv8,
  },
  {
    id: 8,
    name: "Nike Air Max 90 LTR Casual",
    category: "Nike",
    price: "130.00",
    image: Airmax90ltr,
  },
  {
    id: 9,
    name: "Big Kids' Nike Air Force 1 Low Casual",
    category: "Nike",
    price: "90.00",
    image: Bigkids1,
  },
  {
    id: 10,
    name: "Nike Court Vision Mid Next Nature Casual",
    category: "Nike",
    price: "85.00",
    image: Courtvision,
  },
  {
    id: 11,
    name: "Adidas Originals Ozweego Casual",
    category: "Adidas",
    price: "120.00",
    image: Ozweego,
  },
  {
    id: 12,
    name: "Adidas Originals Stan Smith Casual",
    category: "Adidas",
    price: "100.00",
    image: Originalsstan,
  },
  {
    id: 13,
    name: "Adidas Essentials Znsored low Casual",
    category: "Adidas",
    price: "80.00",
    image: Essentialsznsored,
  },
  {
    id: 14,
    name: "Adidas Predator Freak.3 Firm Ground",
    category: "Adidas",
    price: "80.00",
    image: Predatorfreak,
  },
  {
    id: 15,
    name: "Adidas Originals Samba Casual",
    category: "Adidas",
    price: "100.00",
    image: Samba,
  },
  {
    id: 16,
    name: "New Balance 550 Casual",
    category: "New Balance",
    price: "110.00",
    image: Newbalance550,
  },
  {
    id: 17,
    name: "New Balance 574 Casual",
    category: "New Balance",
    price: "90.00",
    image: Newbalance574,
  },
  {
    id: 18,
    name: "New Balance 574 Rugged",
    category: "New Balance",
    price: "90.00",
    image: Newbalance574r,
  },
  {
    id: 19,
    name: "New Balance 9060 Casual",
    category: "New Balance",
    price: "150.00",
    image: Newbalance9060,
  },
  {
    id: 20,
    name: "New Balance CT302 Platform",
    category: "New Balance",
    price: "70.00",
    image: Newbalancect302,
  },
  {
    id: 21,
    name: "New Balance 1906R Casual",
    category: "New Balance",
    price: "160.00",
    image: Newbalance1906r,
  },
  {
    id: 22,
    name: "New Balance 650 Casual",
    category: "New Balance",
    price: "120.00",
    image: Newbalance650,
  },
  {
    id: 23,
    name: "New Balance 530 Casual",
    category: "New Balance",
    price: "100.00",
    image: Newbalance350,
  },
  {
    id: 24,
    name: "New Balance 574 Casual",
    category: "New Balance",
    price: "90.00",
    image: Newbalance574o,
  },
  {
    id: 25,
    name: "New Balance 574 SE Casual",
    category: "New Balance",
    price: "70.00",
    image: Newbalance574se,
  },
  {
    id: 26,
    name: "Puma Suede Classic 21",
    category: "Puma",
    price: "75.00",
    image: Pumasuede21,
  },
  {
    id: 27,
    name: "Puma Mirage Sport Mercedes",
    category: "Puma",
    price: "110.00",
    image: Pumamirage,
  },
  {
    id: 28,
    name: "Puma Axelion Training",
    category: "Puma",
    price: "50.00",
    image: Pumaaxelion,
  },
  {
    id: 29,
    name: "Puma TRC B Block Casual",
    category: "Puma",
    price: "100.00",
    image: Pumatrc,
  },
  {
    id: 30,
    name: "Puma CA Pro Block Casual",
    category: "Puma",
    price: "50.00",
    image: Pumacapro,
  },
  {
    id: 31,
    name: "Puma Caven Casual",
    category: "Puma",
    price: "60.00",
    image: Pumacaven,
  },
  {
    id: 32,
    name: "Puma Rider FV Casual",
    category: "Puma",
    price: "40.00",
    image: Pumarider,
  },
  {
    id: 33,
    name: "Puma Softride Enzo",
    category: "Puma",
    price: "70.00",
    image: Pumasoft,
  },
  {
    id: 34,
    name: "Puma RS 2.0 Casual",
    category: "Puma",
    price: "80.00",
    image: Pumars,
  },
  {
    id: 35,
    name: "Puma RS-TRCK Speckle Casual",
    category: "Puma",
    price: "40.00",
    image: Pumarstrick,
  },

]